// extracted by mini-css-extract-plugin
export var title = "techtime-item-module--title--XScFx";
export var descriptionWrapper = "techtime-item-module--description-wrapper--eptOS";
export var period = "techtime-item-module--period--vnN9d";
export var activity = "techtime-item-module--activity--q7ngX";